import { SpinInfoResponse } from '@cgs/data-access';
import { SpinResultDto } from '../../models';
import { machineStateMapper } from './machine-state.mapper';

export function spinResultMapper(spinResult: SpinResultDto): SpinInfoResponse {
  return {
    machineState: machineStateMapper(spinResult.machineState),
    balance: spinResult.userState.userInfo.balance,
  };
}
